export const getDeepValueByPath = (obj, path) => {
  const split = path.split('.');
	for (let i = 0, len = split.length; i < len; i++) {
		obj = obj[split[i]];
	}
	return obj;
};



// WEBPACK FOOTER //
// ./src/common/utils.js